import { Form, Formik } from 'formik'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { PasswordSchema } from '../../schemas/Campaign/PasswordSchema'
import axiosService from '../../utils/AxiosService'
import Input from '../FormComponents/Input'
import { toastError, toastSuccess } from '../FormComponents/Toasts'

export default function AdvertiserSharedCampaignPassword() {
  const { sharing_token } = useParams()
  const navigate = useNavigate()

  const authenticate = ({ password }) => {
    axiosService.post(`/api/advertiser/campaign_share/sessions`, { sharing_token, password })
    .then(campaign => {
      toastSuccess('Correct password')
      navigate(`/advertiser/campaign_share/${campaign.id}`)
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  return (
    <div className="w-screen h-screen text-center flex flex-col justify-center items-center">
      <p>Please type the password which was shared with you here to unlock the link</p>
      <div className="flex justify-center">
        <Formik
          validationSchema={PasswordSchema}
          initialValues={{ password: '' }}
          onSubmit={authenticate}
        >
          {({ handleBlur, handleChange, values, errors, touched }) => (
            <Form>
              <div className="form-item-container w-full">
                <Input autoFocus error={touched.password && errors.password} placeholder="Password" name='password' onChange={handleChange} onBlur={handleBlur} value={values.password} />
                <button
                  type="submit"
                  className="bg-rb-green text-white px-4 py-2 rounded-2xl w-full mt-4"
                >
                  Submit
                </button>
              </div>
            </Form>
          )}
          </Formik>
      </div>
    </div>
  )
}